module.exports = require('lodash').flow